import { render, staticRenderFns } from "./somenteCliente4DadosDevolucoes.vue?vue&type=template&id=3c527ff5&scoped=true&"
import script from "./somenteCliente4DadosDevolucoes.vue?vue&type=script&lang=js&"
export * from "./somenteCliente4DadosDevolucoes.vue?vue&type=script&lang=js&"
import style0 from "./somenteCliente4DadosDevolucoes.vue?vue&type=style&index=0&id=3c527ff5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c527ff5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
